import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="min-h-screen bg-[#0f0e17] text-white flex items-center justify-center px-4">
            <div className="max-w-md w-full text-center">
                <span className="text-brand font-mono font-semibold text-sm uppercase tracking-widest">
                    Error 404
                </span>
                <h1 className="text-5xl sm:text-6xl font-bold mt-3 font-display">404</h1>
                <h2 className="text-xl sm:text-2xl font-bold mt-2 font-display">
                    Página no encontrada
                </h2>
                <p className="text-gray-400 mt-3 leading-relaxed">
                    La página que buscas no existe o fue movida.
                </p>
                <div className="mt-7">
                    <Link to="/" className="thm-btn">
                        Volver al inicio
                    </Link>
                </div>
            </div>
        </div>
    );
}
